import React from 'react'
import DotsComponent from "./DotsComponent";
const WideCard = (props) => {
  {console.log()}
  return (

    <div className="widecard">
        <DotsComponent/>
        <div className='wide-top' >
            <h1>{props.data.card1up1}</h1>
            <p>{props.data.card1up3}</p>
        </div>
        <div className='wide-bottom'>
         <h5>{props.data.card1dnP}</h5>
        </div>
    </div>
  )
}

export default WideCard
// increased by 3% since last month
// TARGET FOR THIS YEAR